<template>
  <section class="row-span-1 col-span-full grid">
    <div class="z-10 w-full xl:h-[calc(100% - 67px)] top-20 xl:block">
      <div class="restart-block xl:sticky top-0 mt-0 xl:top-[67px] xl:mt-[67px]">
        <h3 class="text-center text-khaki-1 mb-2 font-semibold text-app-primary-1-red--fire-brick text-2xl xl:text-3xl">
          {{ $t('recommendation.suggestion-page.restart-block-title') }}
        </h3>
        <div class="flex justify-center">
          <MoleculeButton
            class="!font-normal mx-auto mt-3 align-bottom group-hover:bg-app-primary-1-red--fire-brick group-focus:bg-app-primary-1-red--fire-brick z-10"
            @click="reset"
          >
            {{ $t('recommendation.suggestion-page.button-start-over') }}
          </MoleculeButton>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
const recommendationsStore = useRecommendationsStore()

function reset() {
  recommendationsStore.reset()
  window.scrollTo({ top: 0, behavior: 'smooth' })
}
</script>
<style scoped lang="scss">
.restart-block {
  @apply rounded-[20px] bg-white p-6;

  @screen xl {
    @apply rounded-l-none rounded-r-[20px] max-h-[calc(100vh*0.8)] overflow-x-hidden w-80;
  }
}

ul {
  @apply mb-6;

  & > li:first-child {
    @apply font-medium;
  }
}

.collapsable {
  transition-property: max-height;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
</style>
